import React, { useEffect, useRef, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Box, Dialog, DialogContent, DialogTitle, Grid } from '@mui/material';
import CustomInput from '../CommonComp/CustomInput/CustomInput';
import CustomButton from '../CommonComp/Buttons/CustomButton';
import { editHiddenKeyword } from '../../Services/keywordsApis';
import { action, logsMessagesList, modulesNames } from '../../data/logsMessages';
import { adminAddLogs } from '../../Services/commonService';
const limit = 10;

function EditHiddenKeyword({ open, handleOpen, getListing, selectedData }) {
  const [loading, setLoading] = useState(false);
  const handleConfirm = async (values, { resetForm }) => {
    setLoading(true)
    let resp = await editHiddenKeyword(values)
    if(resp){
      let payloadForLogs = {
        action: action?.update,
        module: modulesNames?.keywords,
        description: logsMessagesList?.keyword?.keywordHiddenEdit,
      };
      await adminAddLogs(payloadForLogs);
      resetForm({
        hidden_keyword_id : '',  
        hidden_keyword_name : "",
        hidden_keyword_status : "0",
      })
      getListing()
      handleOpen(false)
    }
    setLoading(false)
  };

  const formik = useFormik({
    initialValues: {
      hidden_keyword_id: selectedData?.aid,
      hidden_keyword_name : selectedData?.all_keyword || "",
      hidden_keyword_status : selectedData?.status ? "1" : "0",
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      hidden_keyword_id: Yup.number().required('Hidden keyword id is required.'),
      hidden_keyword_name: Yup.string().required('Hidden keyword name is required.'),
      hidden_keyword_status: Yup.string().required('Hidden keyword status is required.')
    }),
    onSubmit: handleConfirm,
  });

  return (
    <div>
      <Dialog
        maxWidth={'sm'}
        open={open}
        onClose={() => {
          handleOpen(false);
        }}
        fullWidth
      >
        <DialogTitle variant='h3'>Edit Hidden Keyword</DialogTitle>
        <DialogContent>
        <Box
            noValidate
            component="form"
            // sx={{
            //   width: 400
            // }}
            onSubmit={formik.handleSubmit}
          >
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <CustomInput
                  variant="outlined"
                  fullWidth
                  name="hidden_keyword_name"
                  label="Hidden Keyword"
                  placeholder="Enter Hidden Keyword"
                  value={formik.values.hidden_keyword_name}
                  onChange={formik.handleChange}
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    classes: {
                      notchedOutline: 'rounded',
                    },
                  }}
                  error={formik.touched.hidden_keyword_name && Boolean(formik.errors.hidden_keyword_name)}
                  helperText={formik.touched.hidden_keyword_name && formik.errors.hidden_keyword_name}
                />
              </Grid>
              <Grid item xs={12}>
                <CustomInput
                  variant="outlined"
                  fullWidth
                  name="hidden_keyword_status"
                  label="Status"
                  placeholder="Status"
                  value={formik.values.hidden_keyword_status}
                  select
                  SelectProps={{
                    native: true
                  }}
                  InputLabelProps={{ shrink: true }}
                  onChange={formik.handleChange}
                  InputProps={{
                    classes: {
                      notchedOutline: 'rounded',
                    },
                  }}
                  error={formik.touched.hidden_keyword_status && Boolean(formik.errors.hidden_keyword_status)}
                  helperText={formik.touched.hidden_keyword_status && formik.errors.hidden_keyword_status}
                >
                  <option value={"0"}>Inactive</option>
                  <option value={"1"}>Active</option>
                </CustomInput>
              </Grid>
            </Grid>
            <div style={{ display: 'flex', justifyContent: 'end', marginTop: 15 }}>
              <CustomButton color={'buttonPrimary'} type="submit" loading={loading}>Confirm</CustomButton>
              <CustomButton
                onClick={() => {
                    formik.resetForm({
                      hidden_keyword_id: "",
                      hidden_keyword_name : "",
                      hidden_keyword_status : "",
                    });
                    handleOpen(false)}
                }
                disabled={loading}
              >Cancel</CustomButton>
            </div>
          </Box>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default EditHiddenKeyword;
